namespace $ {
	/** One-shot native visibility subscription, released with its reactive owner. */
	export class $shm_hitalama_map_widget_float_code_textarea_visible extends $mol_object {
		private observer: IntersectionObserver

		constructor( node: Element, reveal: ()=> void ) {
			super()
			this.observer = new IntersectionObserver( entries => {
				if( !entries.some( entry => entry.isIntersecting ) ) return
				this.observer.disconnect()
				reveal()
			}, { rootMargin: '300px' } )
			this.observer.observe( node )
		}

		destructor() { this.observer.disconnect(); super.destructor() }
	}
}
